import { AssistentItem } from '../assistent_config';
import { DateneingabeVSMEAuswahl } from '../../DateneingabeVSMEAuswahl';
import { HinweiseElementVsme } from '../../assistent/items/custom/HinweiseElementVsme';
import { IDs } from '../../../../helpers/IDs';
import React from 'react';
import { StructureService } from '../../../../services/structure_service';
import { TriggerService } from '../../../../core/trigger/trigger_service';

export function getVsmeBpmEntities(): any[] {
    const group = 'vsme_bpm';
    const infoTextStyle = { maxWidth: 600 };
    return [
        { gliederung: '4.', gliederung2: 'III.', collapsible: group, name: 'BPM-Modul' },
        { gliederung: '4.1', key: IDs.ENT_VSME_BPM1, group, singleItem: true },
        { gliederung: '4.2', key: IDs.ENT_VSME_BPM2, group, singleItem: true },
        { gliederung: '4.3', key: IDs.ENT_VSME_BPM3, group, singleItem: true, infoTextKey: 'hinweis_vsme_bpm_bpm3', infoTextStyle },
        { gliederung: '4.4', key: IDs.ENT_VSME_BPM4, group, singleItem: true },
        { gliederung: '4.5', key: IDs.ENT_VSME_BPM5, group, singleItem: true },
        { gliederung: '4.6', key: IDs.ENT_VSME_BPM6, group, singleItem: true },
        { gliederung: '4.7', key: IDs.ENT_VSME_BPM7, group, singleItem: true, infoTextKey: 'hinweis_vsme_bpm_bpm7', infoTextStyle },
        { gliederung: '4.8', key: IDs.ENT_VSME_BPM8, group, singleItem: true },
        { gliederung: '4.9', key: IDs.ENT_VSME_BPM9, group, singleItem: true },
        { gliederung: '4.10', key: IDs.ENT_VSME_BPM10, group, singleItem: true },
        { gliederung: '4.11', key: IDs.ENT_BETRIEBSDATEN, group, singleItem: true, name: 'BP11: Anzahl der Auszubildenden' }
    ];
}

export function getAssistentConfigVsmeBpmItems(standort: any, data: any, jahr: number, triggerService: TriggerService, structureService: StructureService): AssistentItem[] {
    const ents = getVsmeBpmEntities();
    const category = 'vsme_bpm';
    const items: AssistentItem[] = ents.map((e: any) => {
        if (e.collapsible && !e.key) {
            return {
                collapsible: e.collapsible,
                group: e.group,
                gliederung: e.gliederung,
                gliederung2: e.gliederung2,
                name: e.name,
                style: { backgroundColor: '#616468', color: 'white' },
                type: 'CustomGroupElement',
                customElements: [
                    <div style={{ marginBottom: 10 }}>
                        <HinweiseElementVsme
                            stlye={{ maxWidth: 743, margin: 0 }}
                            textKey='hinweis_vsme_bpm'
                            data={data}
                        />
                    </div>,
                    <DateneingabeVSMEAuswahl
                        key={`vsme_auswahl_${category}`}
                        category={category}
                        data={data}
                        standortSelected={standort}
                        jahrFix={jahr}
                        hideJahr={true}
                        showHelpIcon={true}
                    />
                ]
            };
        }
        const structure = structureService.getStructureByKey(IDs.MOD_ETOOL, e.key) || {};
        return {
            collapsible: e.collapsible,
            group: e.group,
            gliederung: e.gliederung,
            gliederung2: e.gliederung2,
            name: e.name || structure.TITEL,
            dataName: structure.TITEL,
            description: 'Dies ist das Formular zur Eingabe der VSME-Daten.',
            type: 'EntityForm',
            addLabel: `Neuen Datensatz erfassen`,
            entity: e.key,
            configFlag: 'inputVsmeBpm',
            singleItem: e.singleItem,
            customOnSaveDone: (ent: string, dataItem: any) => {
                triggerService.fire('reload', ent);
            },
            infoTextKey: e.infoTextKey,
            infoTextStyle: e.infoTextStyle
        }
    });
    return items;
}
